import { Injectable } from '@angular/core';
import { RestaurantStatisticsRepository } from "../../repositories/base/restaurant-statistics.repository";
import { KeycloakService } from "keycloak-angular";
import {PostPayloadInterface} from "../../models/post-payload.interface";
import {Utilities} from "../../utils/utilities";

@Injectable({
  providedIn: 'root'
})
export class RestaurantStatisticsService {

  constructor(private repo: RestaurantStatisticsRepository) {
  }

  public getStatisticForRestaurant(restaurantHistoryId:number, date:Date){
      const payload = new StatisticPayload(restaurantHistoryId, Utilities.dateToBackendDateTimeString(date, true))
      return this.repo.getStatistics(payload);
  }
}
export class StatisticPayload implements PostPayloadInterface{
    attribute: any;
    id: number;
    type: string;
    reference:string;

    constructor(id: number, reference: string) {
        this.id = id;
        this.reference = reference;
    }
}
